import stylesheet_0 from '../stylesheets/0.js';

export const index = 1;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/pages/_error.svelte.js')).default;
export const imports = ["_app/immutable/nodes/1.61d58d6c.js","_app/immutable/chunks/scheduler.cba25ae0.js","_app/immutable/chunks/index.e8799153.js","_app/immutable/chunks/four_planes.582a9558.js","_app/immutable/chunks/stores.93b901f8.js","_app/immutable/chunks/singletons.805964db.js","_app/immutable/chunks/index.6d2b3d0a.js"];
export const stylesheets = ["_app/immutable/assets/1.f51e04b3.css"];
export const fonts = [];
export const inline_styles = () => ({
	"_app/immutable/assets/1.f51e04b3.css": stylesheet_0
});
